import { useQuery } from "react-query";
import { GET_FAMILY_HISTORY, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getFamilyHistory } from "api/customers";

const useGetFamilyHistory = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_FAMILY_HISTORY, clientId],
    () => getFamilyHistory(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    familyHistory: data?.data || null,
    familyHistoryLoading: isLoading,
    refetchFamilyHistory: refetch,
    ...rest,
  };
};

export default useGetFamilyHistory;
